// Dial codes, country, and timezone derivation helpers for frontend (WP-03).
// Mirrors shared/whatsapp/dialCodes.ts.

export interface DialCodeEntry {
  prefix: string;
  iso2: string;
  name: string;
  timezone: string;
}

export const DIAL_CODES: DialCodeEntry[] = [
  // 3-digit prefixes
  { prefix: '968', iso2: 'OM', name: 'Oman', timezone: 'Asia/Muscat' },
  { prefix: '966', iso2: 'SA', name: 'Saudi Arabia', timezone: 'Asia/Riyadh' },
  { prefix: '971', iso2: 'AE', name: 'United Arab Emirates', timezone: 'Asia/Dubai' },
  { prefix: '973', iso2: 'BH', name: 'Bahrain', timezone: 'Asia/Bahrain' },
  { prefix: '974', iso2: 'QA', name: 'Qatar', timezone: 'Asia/Qatar' },
  { prefix: '965', iso2: 'KW', name: 'Kuwait', timezone: 'Asia/Kuwait' },
  { prefix: '962', iso2: 'JO', name: 'Jordan', timezone: 'Asia/Amman' },
  { prefix: '961', iso2: 'LB', name: 'Lebanon', timezone: 'Asia/Beirut' },
  { prefix: '964', iso2: 'IQ', name: 'Iraq', timezone: 'Asia/Baghdad' },
  { prefix: '967', iso2: 'YE', name: 'Yemen', timezone: 'Asia/Aden' },
  { prefix: '963', iso2: 'SY', name: 'Syria', timezone: 'Asia/Damascus' },
  { prefix: '970', iso2: 'PS', name: 'Palestine', timezone: 'Asia/Gaza' },
  { prefix: '212', iso2: 'MA', name: 'Morocco', timezone: 'Africa/Casablanca' },
  { prefix: '213', iso2: 'DZ', name: 'Algeria', timezone: 'Africa/Algiers' },
  { prefix: '216', iso2: 'TN', name: 'Tunisia', timezone: 'Africa/Tunis' },
  { prefix: '218', iso2: 'LY', name: 'Libya', timezone: 'Africa/Tripoli' },
  { prefix: '249', iso2: 'SD', name: 'Sudan', timezone: 'Africa/Khartoum' },
  { prefix: '880', iso2: 'BD', name: 'Bangladesh', timezone: 'Asia/Dhaka' },
  { prefix: '234', iso2: 'NG', name: 'Nigeria', timezone: 'Africa/Lagos' },
  { prefix: '254', iso2: 'KE', name: 'Kenya', timezone: 'Africa/Nairobi' },

  // 2-digit prefixes
  { prefix: '20', iso2: 'EG', name: 'Egypt', timezone: 'Africa/Cairo' },
  { prefix: '44', iso2: 'GB', name: 'United Kingdom', timezone: 'Europe/London' },
  { prefix: '91', iso2: 'IN', name: 'India', timezone: 'Asia/Kolkata' },
  { prefix: '92', iso2: 'PK', name: 'Pakistan', timezone: 'Asia/Karachi' },
  { prefix: '90', iso2: 'TR', name: 'Turkey', timezone: 'Europe/Istanbul' },
  { prefix: '49', iso2: 'DE', name: 'Germany', timezone: 'Europe/Berlin' },
  { prefix: '33', iso2: 'FR', name: 'France', timezone: 'Europe/Paris' },
  { prefix: '39', iso2: 'IT', name: 'Italy', timezone: 'Europe/Rome' },
  { prefix: '34', iso2: 'ES', name: 'Spain', timezone: 'Europe/Madrid' },
  { prefix: '60', iso2: 'MY', name: 'Malaysia', timezone: 'Asia/Kuala_Lumpur' },
  { prefix: '62', iso2: 'ID', name: 'Indonesia', timezone: 'Asia/Jakarta' },
  { prefix: '63', iso2: 'PH', name: 'Philippines', timezone: 'Asia/Manila' },
  { prefix: '65', iso2: 'SG', name: 'Singapore', timezone: 'Asia/Singapore' },
  { prefix: '81', iso2: 'JP', name: 'Japan', timezone: 'Asia/Tokyo' },
  { prefix: '82', iso2: 'KR', name: 'South Korea', timezone: 'Asia/Seoul' },
  { prefix: '86', iso2: 'CN', name: 'China', timezone: 'Asia/Shanghai' },
  { prefix: '61', iso2: 'AU', name: 'Australia', timezone: 'Australia/Sydney' },
  { prefix: '55', iso2: 'BR', name: 'Brazil', timezone: 'America/Sao_Paulo' },
  { prefix: '27', iso2: 'ZA', name: 'South Africa', timezone: 'Africa/Johannesburg' },

  // 1-digit prefixes
  { prefix: '1', iso2: 'US', name: 'United States', timezone: 'America/New_York' },
  { prefix: '7', iso2: 'RU', name: 'Russia', timezone: 'Europe/Moscow' },
];

export function deriveCountryFromPhone(phoneE164: string): { country: string; timezone: string; name: string } | null {
  if (!phoneE164) return null;
  const digits = phoneE164.replace(/\D/g, '');
  if (!digits) return null;

  for (const entry of DIAL_CODES) {
    if (digits.startsWith(entry.prefix)) {
      return {
        country: entry.iso2,
        timezone: entry.timezone,
        name: entry.name,
      };
    }
  }

  return null;
}
